module.exports = __webpack_public_path__ + "img/store-item.f36955e8.svg";